import PropTypes from 'prop-types';
import React from 'react';

const FilledCircularProgress = ({ size, percentage, backgroundColor, progressColor, children }) => {
  const radius = size / 2;
  const innerRadius = radius * 0.85; // Slightly smaller to create a border effect
  
  // Calculate the path for the filled arc
  const createPath = (percent) => {
    if (percent === 0) return '';
    if (percent === 100) return `M ${radius} ${radius} m 0 -${innerRadius} a ${innerRadius} ${innerRadius} 0 1 1 0 ${2 * innerRadius} a ${innerRadius} ${innerRadius} 0 1 1 0 -${2 * innerRadius} Z`;
    
    const angle = (percent / 100) * 2 * Math.PI;
    const x = radius + innerRadius * Math.sin(angle);
    const y = radius - innerRadius * Math.cos(angle);
    const largeArcFlag = percent > 50 ? 1 : 0;
    
    return `M ${radius} ${radius} L ${radius} ${radius - innerRadius} A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 1 ${x} ${y} Z`;
  };

  return (
    <div style={{ width: size, height: size, position: 'relative' }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {/* Background circle */}
        <circle 
          cx={radius} 
          cy={radius} 
          r={innerRadius} 
          fill={backgroundColor}
        />
        {/* Progress fill */}
        {percentage > 0 && (
          <path
            d={createPath(percentage)}
            fill={progressColor}
          />
        )}
      </svg>
      {/* Content overlay */}
      {children && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

FilledCircularProgress.propTypes = {
  size: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  backgroundColor: PropTypes.string,
  progressColor: PropTypes.string,
  children: PropTypes.node,
};

FilledCircularProgress.defaultProps = {
  backgroundColor: '#E0E0E0',
  progressColor: '#41D158',
  children: null,
};

export default FilledCircularProgress;